import React from 'react';

interface GrowthRateInputProps {
  value: number;
  onChange: (value: number) => void;
}

export const GrowthRateInput: React.FC<GrowthRateInputProps> = ({ value, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value);
    onChange(isNaN(newValue) ? 0 : newValue);
  };

  return (
    <div className="growth-rate-input">
      <label htmlFor="growth-rate">Growth Rate (%)</label>
      <input
        id="growth-rate"
        type="number"
        min="-100"
        max="1000"
        step="0.1"
        value={value}
        onChange={handleChange}
      />
      <small>Enter expected growth rate for the forecast period</small>
    </div>
  );
}; 